export default {"src":"/_next/static/media/wechat-icon-dark.095bd1a9.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};